/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/require-default-props */
import React from "react";

type containerProps = {
  children?: React.ReactNode;
  style?: object;
  className?: string;
  ref?: string;
};

export const Container: React.FC<containerProps> = ({ style, children, className, ref }) => (
  <div ref={ref} className={`container ${className}`} style={style}>
    {children}
  </div>
);

Container.defaultProps = {
  children: undefined,
  style: undefined,
  className: undefined,
};

type rowProps = {
  /**
   * Children contents elements
   */
  children?: React.ReactNode;
  /**
   * Custom style to pass to the component
   */
  style?: object;
  /**
   * Custom class name to pass to the component
   */
  className?: string;
  ref?: string | any;
};

export const Row: React.FC<rowProps> = ({ style, children, className, ref }) => (
  <div ref={ref} className={`row ${className}`} style={style}>
    {children}
  </div>
);

Row.defaultProps = {
  children: undefined,
  style: undefined,
  className: undefined,
};

type colProps = {
  /**
   * Children contents elements
   */
  children?: React.ReactNode;
  /**
   * Custom style to pass to the component
   */
  style?: object;
  /**
   * Custom class name to pass to the component
   */
  className?: string;
  /**
   * Column class name for small devices
   */
  sm?: "0" | "1" | "2" | "3" | "4" | "5" | "6" | "8" | "9" | "10" | "11" | "12";
  /**
   * Column class name for medium devices
   */
  md?: "0" | "1" | "2" | "3" | "4" | "5" | "6" | "8" | "9" | "10" | "11" | "12";
  /**
   * Column class name for large devices
   */
  lg?: "0" | "1" | "2" | "3" | "4" | "5" | "6" | "8" | "9" | "10" | "11" | "12";
  /**
   * Column class name for extra large devices
   */
  xl?: "0" | "1" | "2" | "3" | "4" | "5" | "6" | "8" | "9" | "10" | "11" | "12";
};

export const Col: React.FC<colProps> = ({ style, children, className, sm, md, lg, xl }) => (
  <div className={`col col-sm-${sm} col-md-${md} col-lg-${lg} col-xl-${xl} ${className}`} style={style}>
    {children}
  </div>
);

Col.defaultProps = {
  children: undefined,
  style: undefined,
  className: undefined,
  // sm: '12',
  // md: '12',
  // lg: '12',
};

type boxProps = {
  /**
   * Children contents elements
   */
  children?: React.ReactNode;
  /**
   * Custom class name to pass to the component
   */
  className?: string;
  /**
   * Custom style to pass to the component
   */
  style?: object;
  /**
   * Element reference
   */
  eRef?: any;
  /**
   * Element id
   */
  id?: any;
  /**
   * onClick event handler
   */
  onClick?: () => {};
};

export const Box: React.FC<boxProps> = ({ children, className, style, eRef, id, onClick }) => (
  <div ref={eRef} id={id} onClick={onClick} className={`box ${className}`} style={style}>
    {children}
  </div>
);

Box.defaultProps = {
  children: undefined,
  className: undefined,
  style: undefined,
};

type HStackProps = {
  /**
   * Children contents elements
   */
  children?: React.ReactNode | React.ReactNode[];
  /**
   * Custom class name to pass to the component
   */
  className?: string;
};

export const HStack = (props: HStackProps | undefined) => {
  if (!props) return <></>;

  const { children, className } = props;

  return (
    <Box className={className} style={{ alignItems: "center", display: "flex", flexDirection: "row" }}>
      {children}
    </Box>
  );
};

type VStackProps = {
  /**
   * Children contents elements
   */
  children?: React.ReactNode;
  /**
   * Custom class name to pass to the component
   */
  className?: string;
};

export const VStack = (props: VStackProps | undefined) => {
  if (!props) return <></>;

  const { children, className } = props;

  return (
    <Box className={className} style={{ display: "flex", flexDirection: "column" }}>
      {children}
    </Box>
  );
};
